import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Checkbox, ConfigProvider, Dropdown, Flex, Row, Space, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import { formatDate } from "utils/formatter";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { REQUEST_APPROVE_TAB } from "features/requestApproval/schemas/RequestApproveTab";
import { useState } from "react";
const RequestFormTable = ({
    modalFlag = true,
    isLoading = false,
    pagination = {},
    dataSource = [],
    onEdit = () => { },
    onDelete = () => { },
    onChange = () => { },
    onApprove = () => { },
    onCancel = () => { },
    onReject = () => { },
    onReturn = () => { },
    onOpenModal = () => { },
    pageType = "",
    onApproveAll = () => { },
    onRejectAll = () => { },
}) => {
    const { t, i18n } = useTranslation();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const hasSelected = selectedRowKeys.length > 0;

    const columns = [
        {
            title: <div className="text-table">{t('req_id.req_id')}</div>,
            dataIndex: "sequence",
            key: "sequence",
            visible: true,
        },
        {
            title: <div className="text-table">{t('request_all.request_type')}</div>,
            dataIndex: "documentType",
            key: "documentType",
            visible: true,
            render: (text, record) => {
                return i18n.language === 'en' ? record?.documentFormType?.nameEn : record?.documentFormType?.name
            }
        },
        {
            title: <div className="text-table">{t('name-surname')}</div>,
            dataIndex: "employee",
            key: "employee",
            visible: true,
            render: (text, record) => {
                return i18n.language === 'en' ? record?.employee?.nameAndSurnameEn : record?.employee?.nameAndSurname
            }
        },
        {
            title: <div className="text-table">{t('request_all.submission_date')}</div>,
            dataIndex: "submissionDate",
            key: "incidentDate",
            visible: true,
            render: (text, record) => {
                return i18n.language == "en" ? dayjs(record?.submissionDate).format("DD/MM/YYYY") : dayjs(record?.submissionDate).format("DD/MM/BBBB")
            }
        },
        {
            title: <div className="text-table">{t('request_all.preferred_detail')}</div>,
            dataIndex: "description",
            key: "description",
            visible: true,
        },
        {
            title: <div className="text-table">{t('request_all.approver')}</div>,
            dataIndex: "companyRegulations",
            key: "companyRegulations",
            visible: true,
            render: (text, record) => {
                const approver = i18n.language === 'en'
                    ? record.approver?.map(obj => obj.nameAndSurnameEn)
                    : record.approver?.map(obj => obj.nameAndSurname);
                return approver.join(" , ")
            }
        },

        {
            title: <div className="text-table">{t('my_document.status')}</div>,
            dataIndex: "status",
            key: "status",
            align: "center",
            visible: true,
            render: (text, record) => {
                let language = i18n.language == "en" ? "En" : ""
                return <StatusTag value={(record?.["approveStatus" + language])} />
                // i18n.language === 'en' ? minitag(record?.approveStatusEn) : minitag(record?.approveStatus)
            },
        },
        {
            title: "",
            key: "action",
            align: "center",
            visible: modalFlag,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    onClick: () => onOpenModal(record),
                                    label: t("action.view"),
                                    icon: <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                                {
                                    key: "2",
                                    onClick: () => onApprove({ ...record, table: REQUEST_APPROVE_TAB.REQUESTFORM }),
                                    label: `${t("action.approve")}`,
                                    icon: (
                                        <CheckOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                        />
                                    ),
                                },
                                {
                                    key: "3",
                                    onClick: () => onReject({ ...record, table: REQUEST_APPROVE_TAB.REQUESTFORM }),
                                    label: `${t("action.reject")}`,
                                    icon: (
                                        <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        },

    ];

    const visibleColumns = columns.filter((col) => col.visible);

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <Flex vertical gap={16}>
            <ConfigProvider
                theme={{
                    components: {
                        Table: {
                            selectionColumnWidth: "45px"
                        },
                    },
                }}
            >
                <TableAntd
                    loading={isLoading}
                    pagination={{
                        ...pagination,
                        showTotal: (total, range) =>
                            t("paginate.description")
                                .replace("{min}", range[0])
                                .replace("{max}", range[1])
                                .replace("{total}", total),
                    }}
                    dataSource={dataSource}
                    rowKey={(record) => record.id}
                    columns={visibleColumns}
                    onChange={onChange}
                    rowSelection={pageType === "view" ? rowSelection : undefined}
                />
            </ConfigProvider>

            {hasSelected && pageType === "view" &&
                (<Flex vertical gap={8} style={{ alignItems: "end" }}>
                    <span>{`${t("common.selected")} ${selectedRowKeys.length} ${t("common.items")}`}</span>
                    <Row style={{ gap: "8px" }}>
                        <Button
                            type="default"
                            style={{ borderRadius: "8px", height: "40px" }}
                            onClick={() => {
                                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                                onRejectAll(selectedRecords).then(() => {
                                    setSelectedRowKeys([]);
                                });
                            }}
                        >
                            {t("request_approval.label.not_approved")}</Button>
                        <Button
                            type="primary"
                            style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
                            onClick={() => {
                                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                                onApproveAll(selectedRecords).then(() => {
                                    setSelectedRowKeys([]);
                                });
                            }}
                        >{t("request_approval.label.approve")}</Button>
                    </Row>
                </Flex>)}
        </Flex>
    );
};

export default RequestFormTable;
